export const GAMETYPE_MODE_OPTIONS = [
  { label: 'Staging', value: 'staging' },
  { label: 'Production', value: 'production' }
];

export const DUMMY_QUIZ_DATA = {
  description: '',
  title: '',
  subtype: null,
  metadata: {
    questions: [
      {
        id: 1775452539417,
        text: 'what is the best course of action to mitigate the global impact due to war?',
        options: [
          { id: 1775452539418, text: 'The need to expand military bases along the strait', isCorrect: false },
          {
            id: 1775452539419,
            text: 'The importance of maintaining safe shipping lanes to protect the global economy',
            isCorrect: true
          },
          { id: 1775452539420, text: 'The requirement for all oil exports to be halted immediately', isCorrect: false },
          {
            id: 1775452539421,
            text: 'The plan to deploy Chinese naval forces to escort all tankers',
            isCorrect: false
          }
        ]
      },
      {
        id: 1775452539422,
        text: 'What action did the US State Department take regarding its personnel in Bahrain, Jordan, and Iraq?',
        options: [
          {
            id: 1775452539423,
            text: 'It increased the number of military advisers in those countries',
            isCorrect: false
          },
          { id: 1775452539424, text: 'It ordered non-emergency personnel to leave those countries', isCorrect: true },
          { id: 1775452539425, text: 'It closed all embassies and consulates permanently', isCorrect: false },
          { id: 1775452539426, text: 'It moved all staff to the Strait of Hormuz region', isCorrect: false }
        ]
      },
      {
        id: 1775452539427,
        text:
          "What consequence did the drone attack on Oman's Duqm commercial port have, according to the Oman News Agency?",
        options: [
          { id: 1775452539428, text: 'It caused multiple fatalities among port workers', isCorrect: false },
          { id: 1775452539429, text: 'It led to a large oil spill into the sea', isCorrect: false },
          { id: 1775452539430, text: 'Damage to a fuel tank was contained with no human casualties', isCorrect: true },
          { id: 1775452539431, text: 'It forced the complete evacuation and closure of the port', isCorrect: false }
        ]
      },
      {
        id: 1775452539432,
        text: 'What measure did the US Embassy in Riyadh take following reported Iranian drone attacks?',
        options: [
          { id: 1775452539433, text: 'It relocated staff to Bahrain and Jordan', isCorrect: false },
          { id: 1775452539434, text: 'It continued only emergency services in Riyadh', isCorrect: false },
          {
            id: 1775452539435,
            text: 'It cancelled all routine and emergency American Citizen Services appointments',
            isCorrect: true
          },
          { id: 1775452539436, text: 'It reopened for limited in-person appointments', isCorrect: false }
        ]
      }
    ]
  },
  id: '4a38ce5d-65ff-49a7-943f-4fd277d14b8d',
  'family-id': 'e33ac666-62ed-4dd7-9f8f-1282f4f084e5',
  type: 'quiz',
  'page-url': '/story/d3269390-3e4a-40c1-b104-2b334820b44c/element/4a38ce5d-65ff-49a7-943f-4fd277d14b8d'
};
